import { BasicInfoCompany } from "./interfaces/basicInfoCompany.interface";
import { WorkflowStage } from "./interfaces/WorkflowInterface";
import { Batch } from "./Batch.interface";
import { Comment } from "./comment.interface";
import { Company } from "./Company.interface";
import { Material } from "./material.interface";
import { User } from "./UserInterface";

type BaseType = {
  id?: number;
  createdAt?: Date;
  updatedAt?: Date;
  metadata?: string;
};

export type BaseWithCompany = {
  company?: any;
} & BaseType;

export type Upload = {
  uuid: string;
  fileName: string;
  order: Order;
  orderItem: OrderItem;
  loaded: number;
  total: number;
  status: "uploading" | "done" | "error";
  startedDate: Date;
};

interface OrderItemsResponse {
  data: OrderItem[];
  total: number;
}

export type WorkflowStageAction = {
  code: string;
  name: string;
  description: string;
  destinataries: string[];
  workflowStage?: WorkflowStage;
  workflowStageId: number;
} & BaseType;

export type CustomField = {
  id?: number;
  name: string;
  label: string;
  fieldType: CustomFieldTypes;
  options?: string[];
  entity: string;
  isInternal: boolean;
  defaultValue?: string;
  companyId?: number;
};
export type CustomFieldValues = {
  id?: number;
  entity: string;
  entityId: number;
  customField: CustomField;
  customFieldId: number;
  value: string;
};
export type CustomDialogField = {
  id?: number;
  customDialog?: CustomDialog;
  customDialogId: number;
  customField: CustomField;
  customFieldId: number;
  position: number;
  required: boolean;
  readonly: boolean;
  width: number;
  companyId?: number;
};

export type CustomDialog = {
  id?: number;
  name: string;
  title: string;
  entity: string;
  exclusivity?: string;
  customDialogFields: CustomDialogField[];
};

export type Values = {
  [key: number]: {
    customFieldValueId?: number;
    customFieldId: number;
    value: any;
  };
};
export type FileInfo = {
  BitsPerComponent: string;
  ChannelColors: ChannelColors;
  ChannelNames: ChannelNames;
  Colorations: Colorations;
  InkSet: InkSet;
  Pages: string;
  Profile: Profile;
  ResolutionUnits: string;
  ResolutionX: string;
  ResolutionY: string;
  Space: string;
  height: string;
  width: string;
  status?: string;
  message?: string;
};

export type ChannelColors = {
  channel: ChannelColorsChannel[];
};

export type ChannelColorsChannel = {
  $: PurpleAttributes;
};

export type PurpleAttributes = {
  Space: string;
  color: string;
  index: string;
  kind: string;
  opacity: string;
  previewRGB: string;
};

export type ChannelNames = {
  channel: ChannelNamesChannel[];
};

export type ChannelNamesChannel = {
  $: FluffyAttributes;
};

export type FluffyAttributes = {
  index: string;
  name: string;
};

export type Colorations = {
  Coloration: Coloration | Coloration[];
};

export type Coloration = {
  $: ColorationAttributes;
};

export type ColorationAttributes = {
  Id: string;
  name: string;
};

export type InkSet = {
  $: InkSetAttributes;
};

export type InkSetAttributes = {
  NumChannels: string;
};

export type Profile = {
  $: ProfileAttributes;
};

export type ProfileAttributes = {
  Description: string;
  Space: string;
};

export type CompanyPreferences = BaseWithCompany & {
  maxFileSize?: number;
  allowedFileExtensions: string[];
  preprocessLayout?: boolean;
  batchNumber?: number;
  defaultColumnOrder: string[];
  defaultMeasurementUnit?: string;
  printBlankSpace?: boolean;
  printBlankSpaceBetweenBatches?: boolean;
  blankSpaceSize?: number;
  blankSpaceSizeUnit?: string;
  forceSequentialJobs?: boolean;
};

export type Language = {
  locale: "en" | "ca" | "es" | "it";
  code: string;
  name: string;
};
export type CustomFieldTypes = "text" | "textArea" | "number" | "date" | "multiselect" | "checkbox" | "dropdown" | "order-printer";

export type OrderType = BaseWithCompany & {
  name: string;
  description: string;
  workflowStage?: WorkflowStage;
  workflowStageId?: number;
  defaultLayout?: Layout;
  defaultLayoutId?: number;
  defaultPrinter?: Printer;
  defaultPrinterId?: number;
  defaultScheme?: Scheme;
  defaultSchemeId?: number;
};
export type Layout = BaseWithCompany & {
  fileName?: string;
  name: string;
  numberOfPages?: number;
  numberOfInputImages?: number;
  layoutWidth?: string;
  layoutHeight?: string;
  description?: string;
  allowedUsers?: User[];
  visible?: boolean;
};

export type Customer = BasicInfoCompany & {
  name: string;
  surname?: string;
  email?: string;
  phone?: string;
  address?: string;
  city?: string;
  state?: string;
  zip?: string;
  country?: string;
};

interface OrderItemsResponse {
  data: OrderItem[];
  total: number;
}
export type PrintJob = BasicInfoCompany & {
  status: PrintJobStatus;
  statusDetails: string;
  abortDate: Date;
  type: PrintJobType;
  comments: string;
  endDate: Date;
  inkConsumption: string;
  inkConsumptionAsJson: Object;
  percentage: number;
  printedLength: number;
  startDate: Date;
  orderItem?: OrderItem;
  orderItemId?: number;
  file?: ItemFile;
  fileId?: number;
  origin?: string;
  printer: Printer | null;
  printerId: number | null;
  scheme: Scheme | null;
  schemeId: number | null;
  layout: Layout | null;
  layoutId: number | null;
  length: number | null;
  width: number | null;
  lengthUnits: string;
  widthUnits: string;
  widthInPt?: number;
  lengthInPt?: number;
  quantity: number;
  action: PrintJobActions;
  archivedAt?: Date;
  position?: string;
};
export interface ICFile {
  id?: number;
  orderItemId?: number;
  originalName: string;
  createdAt?: string;
  uuid: string;
  version: number;
  type?: string;
  location: string;
  path: string;
  metadata?: any;
  preview?: ICFile;
  otherPreviews?: ICFile[];
}

export interface Printer {
  id?: number;
  name: string;
  active: string;
  UUID: string;
  defaultScheme: string;
  status: string;
  workstation: string;
  url: string;
  port: string;
  hidden: boolean;
  numJobs: number;
  selectedSize: number;
  pendingSize: number;
  schemes?: Scheme[];
  alias: string;
  type: string;
  path: string;
  updatedAt?: Date;
}

export interface Scheme {
  id?: number;
  name: string;
  company?: any;
  companyId?: number;
  printer: Printer;
  printerId: number;
  active: boolean;
  files: ICFile[];
  public: boolean;
  hidden: boolean;
}

export enum PrintJobActions {
  NOTHING = "Nothing",
  QUEUE = "Queue",
  PRINT = "Print",
}
export enum PrintJobStatus {
  PENDING = "PENDING",
  ASSIGNED = "ASSIGNED",
  PROCESSING = "PROCESSING",
  QUEUED = "QUEUED",
  PRINTING = "PRINTING",
  COMPLETED = "COMPLETED",
  ABORTED = "ABORTED",
  CANCELLED = "CANCELLED",
}
//Mission, reason, goal...
export enum PrintJobType {
  PRINT = "PRINT",
  REPRINT = "REPRINT",
  BLANK_SPACE = "blankSpace",
}

export type CustomColumnEntity = "Order" | "OrderItem" | "PrintJob";

export type CustomColumn = {
  header: string;
  field: string;
  frozen: boolean;
  sortable: boolean;
  showFilterMenu?: boolean;
  class?: string;
  type?: string;
  customFieldId?: number;
  filter?: boolean;
  filterField?: string;
  isJobColumn?: boolean;
  entity?: CustomColumnEntity;
  fieldType?: CustomFieldTypes;
  options?: string[];
};

export type Order = {
  id?: number;
  createdAt?: string;
  updatedAt?: string;
  name: string;
  code?: string;
  dueDate?: string | Date | null;
  owner?: Company;
  ownerId?: string;
  receivers?: Company[];
  workflowStageId?: number;
  orderItems: OrderItem[];
  comments: string;
  children?: Order[];
  customer?: any;
  customerId?: number;
  metadata?: any;
  orderType?: OrderType;
  orderTypeId?: number;
  layout?: Layout;
  layoutId?: number;
  createdBy?: User;
  createdById?: number;
  printer?: Printer;
  printerId?: number;
  scheme?: Scheme;
  schemeId?: number;
  preprocessLayout?: boolean;
  orderItemsCount?: number;
  nonAttachmentItemsCount?: number;
  customFieldValues?: CustomFieldValues[];
};
export type OrderItem = {
  line?: any;
  id?: number;
  isNew?: boolean;
  isChangingFile?: boolean;
  isEdited?: boolean;
  isDeleted?: boolean;
  createdAt?: string | Date;
  updatedAt?: string | Date;
  status?: string;
  active?: boolean;
  quantity: number;
  width?: number;
  length?: number;
  widthInPt?: number;
  lengthInPt?: number;
  widthUnits?: "cm" | "m" | "in" | "mm" | "yd" | "ft" | "rep" | string;
  lengthUnits?: "cm" | "m" | "in" | "mm" | "yd" | "ft" | "rep" | string;
  batch?: Batch;
  batchId?: number;
  material?: Material;
  materialId?: number;
  description?: string;
  file?: ItemFile;
  uploadedFile?: any;
  layout?: Layout;
  layoutId?: number;
  children: OrderItem[];
  parent?: OrderItem;
  receivers: Company[];
  company?: Company;
  companyId?: number;
  order?: Order;
  orderId?: number;
  workflowStageId?: number;
  workflowStage?: WorkflowStage;
  position: number;
  currentFile?: ItemFile;
  currentFileId?: number;
  rootComment?: Comment;
  comments?: string;
  client?: string;
  metadata?: any;
  orderType?: OrderType;
  orderTypeId?: number;
  isAttachment?: boolean;
  printer?: Printer;
  printerId?: number;
  scheme?: Scheme;
  schemeId?: number;
  action: PrintJobActions;
  printJobs?: PrintJob[];
  hasPrintJobs?: boolean;
  customFieldValues?: CustomFieldValues[];
  /** Client-only. Applied with replaceFileWithNeoCatalog when the order is saved. */
  pendingNeoCatalogReplacement?: {
    colorway: { id: string | number; colorwayName?: string; colorwayCode?: string };
    originalName: string;
  };
};

export type ItemFile = {
  id?: number;
  orderItemId?: number;
  originalName: string;
  createdAt?: string;
  uuid: string;
  isEncrypted?: boolean;
  version: number;
  type?: string;
  location: string;
  preview?: ItemFile;
  otherPreviews?: ItemFile[];
  path: string;
  metadata?: any;
};
export interface Bucket {
  name: string;
  id: string;
  totalItems: number;
  totalLength: number;
}
